import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f8e1bca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-content-between gap-2" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = { class: "p-input-icon-left float-right" }

import { ref, PropType, watch, computed } from 'vue';
import { useRouter } from 'vue-router';
import { DateUtils } from '@/utils/DateUtils';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import Calendar from 'primevue/calendar';
import Tag from 'primevue/tag';

import { Consultation } from '@/interfaces/Consultation';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultationList',
  props: {
  consultations: {
    type: Array as PropType<Consultation[]>,
    default: () => []
  },
  defaultStartDate: {
    type: Date,
    required: true
  },
  defaultEndDate: {
    type: Date,
    required: true
  }
},
  setup(__props) {

const props = __props;

const router = useRouter();

const filteredConsultations = ref<Consultation[]>([...props.consultations]);

const today = new Date();
const { start, end } = DateUtils.getPayoutBounds(today);
const startDate = ref<Date | null>(start);
const endDate = ref<Date | null>(end);
const searchQuery = ref<string>('');

const safeDisplay = (value: string | undefined): string => value || '';

const clearFilter = () => {
  searchQuery.value = '';
  startDate.value = props.defaultStartDate;
  endDate.value = props.defaultEndDate;
  filteredConsultations.value = [...props.consultations];
  filterData();
};

const filterData = () => {
  let data = [...props.consultations];

  if (startDate.value && endDate.value) {
    data = data.filter((c) => {
      const d = new Date(c.startDate);
      return d >= startDate.value! && d <= endDate.value!;
    });
  }

  if (searchQuery.value) {
    data = data.filter(
      (c) =>
        c.ownerName?.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
  }

  filteredConsultations.value = data.sort((a, b) => {
    return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
  });
};

watch(
  () => props.consultations,
  (newValue) => {
    filteredConsultations.value = [...newValue];
    filterData();
  },
  { immediate: true }
);

watch([startDate, endDate], filterData);

const computedConsultations = computed(() => filteredConsultations.value);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(DataTable), {
      value: computedConsultations.value,
      stripedRows: "",
      paginator: "",
      rows: 10,
      rowsPerPageOptions: [10, 20, 50]
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(Calendar), {
              modelValue: startDate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
              dateFormat: "dd.mm.yy",
              placeholder: "Data start"
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(Calendar), {
              modelValue: endDate.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event)),
              dateFormat: "dd.mm.yy",
              placeholder: "Data finală"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_unref(Button), {
            type: "button",
            class: "p-button-sm",
            icon: "pi pi-filter-slash",
            outlined: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilter()))
          }),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_unref(IconField), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputIcon), { class: "pi pi-search" }),
                _createVNode(_unref(InputText), {
                  class: "md:w-auto w-10rem",
                  onInput: filterData,
                  modelValue: searchQuery.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchQuery).value = $event)),
                  placeholder: "Caută pacient.."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          header: "Pacient",
          field: "ownerName",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(safeDisplay(data.ownerName)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Start",
          field: "startDate",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_unref(DateUtils).formatWithTime(data.startDate)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Stop",
          field: "endDate",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.endDate ? _unref(DateUtils).formatWithTime(data.endDate) : 'ANULATA'), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Durata",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.endDate
              ? _unref(DateUtils).daysBetween(data.startDate, data.endDate) + ' zile'
              : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Caractere utilizate",
          field: "usedCharacters",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(Tag), {
              value: Number(data.usedCharacters) < 0 ? 'N/A' : (Number(data.usedCharacters) || 0).toString()
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})